export class Rooftop {
    class: string;
    id: string;
    title: string;
    constructor(data) {
        this.class = data.class;
        this.id = data.id;
        this.title = data.title;
    }

}


// WEBPACK FOOTER //
// ./src/app/components/class/rooftop.ts